import React from 'react';
import DatePicker from 'react-datepicker';
import { sortBy, uniqueId } from 'lodash';
import { Icon } from 'ui';
import Select from 'components/shared/select';
import LinkButton from 'components/shared/LinkButton';
import DateFormat from 'constants/date_format';
import { setQueryString } from 'utils/url';
import { sendAsyncReportingAppRequest } from 'misc/async_reports_helper';
import DataCardTitle from '../_shared/DataCard/Title';

class ReportOption extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tagId: '',
      groupId: '',
      startDate: null,
      endDate: null,
    };
    this.startDateSelected = this.startDateSelected.bind(this);
    this.endDateSelected = this.endDateSelected.bind(this);
    this.handleGroupSelection = this.handleGroupSelection.bind(this);
    this.handleTagSelection = this.handleTagSelection.bind(this);
    this.handleDownload = this.handleDownload.bind(this);
    this.handleReportingAppDownload =
      this.handleReportingAppDownload.bind(this);
  }

  startDateSelected(startDate) {
    const { endDate } = this.state;
    if (endDate && endDate.isBefore(startDate)) {
      return;
    }
    this.setState({ startDate });
  }

  endDateSelected(endDate) {
    const { startDate } = this.state;
    if (startDate && startDate.isAfter(endDate)) {
      return;
    }
    this.setState({ endDate });
  }

  handleGroupSelection(e) {
    this.setState({ groupId: e.target.value });
  }

  handleTagSelection(e) {
    this.setState({ tagId: e.target.value });
  }

  handleDownload() {
    const csvDownloadLink = setQueryString(this.props.csvRoute, {
      tag_id: this.state.tagId,
      group_id: this.state.groupId,
      start_date: moment(this.state.startDate).format(),
      end_date: moment(this.state.endDate).format(),
    });
    window.location.assign(csvDownloadLink);
  }

  handleReportingAppDownload() {
    sendAsyncReportingAppRequest({
      type: this.props.asyncReportType,
      tag_id: this.state.tagId,
      group_id: this.state.groupId,
      start_date: moment(this.state.startDate).format(),
      end_date: moment(this.state.endDate).format(),
    });
  }

  render() {
    const { groups, tags, title, subtitle, validate, useReportingApp } =
      this.props;
    const { groupId, tagId, startDate, endDate } = this.state;
    const formIsValid =
      validate({ tagId, groupId }) && !!startDate && !!endDate;

    return (
      <div className="DataCard-main">
        <DataCardTitle title={title} subtitle={subtitle} />
        <div className="TagReportsInputBox">
          {tags && (
            <div className="TagReportsInput d-f fd-c">
              <span className="mb-4">
                {t('insights.tag_reports.fields.tag')}
              </span>
              <Select
                className="w-220"
                onChange={this.handleTagSelection}
                value={this.state.tagId || ''}
              >
                <option disabled default value="">
                  {t('insights.tag_reports.fields.select_a_tag')}
                </option>
                {sortBy(tags, 'name').map(tag => (
                  <option key={uniqueId()} value={tag.id}>
                    {tag.name}
                  </option>
                ))}
              </Select>
            </div>
          )}
          <div className="TagReportsInput d-f fd-c">
            <span className="mb-4">
              {t('insights.tag_reports.fields.group')}
            </span>
            <Select
              className="w-220"
              onChange={this.handleGroupSelection}
              value={this.state.groupId || ''}
            >
              <option disabled default value="">
                {t('insights.tag_reports.fields.select_a_group')}
              </option>
              {sortBy(groups, 'name').map(group => (
                <option key={uniqueId()} value={group.id}>
                  {group.name}
                </option>
              ))}
            </Select>
          </div>
          <div className="TagReportsInputBox-datePicker TagReportsInput">
            <span className="mb-4">
              {t('insights.tag_reports.fields.time_period')}
            </span>
            <div className="ai-c d-f jc-sb">
              <DatePicker
                className="NewInput NewInput--light TagReportsInput-dateSelect"
                dateFormat={DateFormat.fixed.NUMERIC_SHORT_MONTH_DAY_YEAR}
                onChange={this.startDateSelected}
                placeholderText={t('common.date_format')}
                selected={startDate}
              />
              <span>to</span>
              <DatePicker
                className="NewInput NewInput--light TagReportsInput-dateSelect"
                dateFormat={DateFormat.fixed.NUMERIC_SHORT_MONTH_DAY_YEAR}
                onChange={this.endDateSelected}
                placeholderText={t('common.date_format')}
                selected={endDate}
              />
            </div>
          </div>
        </div>
        <LinkButton
          className="DataCard-link"
          disabled={!formIsValid}
          onClick={
            useReportingApp
              ? this.handleReportingAppDownload
              : this.handleDownload
          }
          type="primary"
        >
          <Icon name="download" />·
          {useReportingApp
            ? t('common.email_download_link')
            : t('common.download')}
        </LinkButton>
      </div>
    );
  }
}

export default ReportOption;
